import React from 'react';

// Ícone da estrela do Kronex (mesmo padrão visual da tela de Login)
const KronexLogo = () => (
  <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="10" fill="white" fillOpacity="0.2" />
    <path
      d="M20 8L24.5 16H30L25.5 21.5L27.5 29.5L20 25L12.5 29.5L14.5 21.5L10 16H15.5L20 8Z"
      fill="white"
      fillOpacity="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 13L22.8 18.5H27L23.5 22L24.8 27L20 24.2L15.2 27L16.5 22L13 18.5H17.2L20 13Z"
      fill="white"
    />
  </svg>
);

/**
 * Layout compartilhado das páginas públicas de autenticação
 * (ativação de conta, esqueci/redefinir senha).
 * Segue o mesmo padrão visual da tela de Login.
 */
const AuthLayout = ({ title, children }) => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 px-4 py-12 sm:px-6 lg:px-8">
    <div className="w-full max-w-md">
      {/* Card */}
      <div className="bg-white rounded-3xl shadow-2xl shadow-blue-900/10 overflow-hidden border border-gray-100/50">
        {/* Header */}
        <div className="bg-[#1e3a5f] px-8 py-8 text-center relative overflow-hidden">
          <div className="absolute -top-10 -right-10 w-32 h-32 bg-blue-500/20 rounded-full blur-2xl"></div>
          <div className="absolute -bottom-10 -left-10 w-24 h-24 bg-indigo-500/20 rounded-full blur-xl"></div>

          <div className="flex justify-center mb-3 relative z-10">
            <div className="p-2.5 bg-white/10 rounded-2xl backdrop-blur-sm ring-1 ring-white/20 shadow-lg shadow-black/10">
              <KronexLogo />
            </div>
          </div>
          <h1 className="text-2xl font-bold text-white tracking-tight relative z-10">Kronex</h1>
          <p className="text-blue-200/80 text-sm mt-1.5 font-medium tracking-wide relative z-10">
            Gestão de Consultores
          </p>
        </div>

        {/* Conteúdo */}
        <div className="p-8 sm:p-10 pt-6">
          {title && (
            <h2 className="text-xl font-semibold text-gray-800 mb-6">{title}</h2>
          )}
          {children}
        </div>
      </div>

      <p className="text-center text-gray-400 text-xs mt-6 tracking-wide">
        © {new Date().getFullYear()} Kronex. Todos os direitos reservados.
      </p>
    </div>
  </div>
);

export default AuthLayout;
